module.exports = __webpack_public_path__ + "img/mining_full.77cf2ef9.webp";